<template>
  <el-dialog
    class="change-loss-dialog"
    size="tiny"
    title="Are you sure you want to leave?"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible="visible">
    <el-row type="flex">
      <el-col>
        <el-row type="flex" align="middle">
          Changes you made will not be saved.
        </el-row>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">
        Cancel
      </el-button>
      <el-button type="primary" @click="confirmRouteLeave">
        Confirm
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'changeLossModal',
    methods: {
      confirmRouteLeave () {
        const { path } = this.$store.getters.getDestinationRoute
        return this.$store.dispatch('confirmRouteLeave', true)
          .then(() => {
            this.$store.dispatch('changeModalVisibility')
            this.$router.push({ path })
            return this.$store.dispatch('setDestinationRoute')
          })
          .catch(e => console.log(e))
      },
      close () {
        return this.$store.dispatch('changeModalVisibility', { entityType: 'changeLossModal', visible: false })
      }
    },
    computed: {
      visible () {
        const visible = this.$store.getters.getModalVisibilityState
        if (visible.changeLossModal && typeof visible.changeLossModal === 'object' && visible.changeLossModal.visible) {
          return visible.changeLossModal.visible
        }
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ChangeLossModal.vue